import React from "react";
import { CheckCircle2 } from "lucide-react";

// A numbered step in the canary rollout, with the state that gates it. The
// number becomes a tick once `done`, so the two steps read as a sequence with a
// position in it rather than as two buttons that happen to sit side by side.
const RolloutStep = ({ step, done, state, children }) => (
    <div className="flex flex-col gap-1">
        <div className="flex items-center gap-1.5">
            <span
                className={`inline-flex h-4 w-4 items-center justify-center rounded-full text-[10px] font-semibold ${
                    done
                        ? "bg-tone-emerald-soft text-tone-emerald"
                        : "bg-background-icon text-text-secondary"
                }`}
                aria-hidden="true"
            >
                {done ? <CheckCircle2 size={10} /> : step}
            </span>
            {children}
        </div>
        <div className="text-[10px] text-text-secondary pl-[22px]">{state}</div>
    </div>
);

export default RolloutStep;
